module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-32.67443103.png";